import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import viewMixin from '../../../components/core/consumers/viewMixin';
import { mapState } from 'vuex';
import pullAt from 'lodash/pullAt';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreTenantOauthClientConfig',
  mixins: [viewMixin],
  props: {
    tenant: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      deleteDialog: false,
      deleteClientIndex: -1,
      clients: [],
      cMOptions: {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  watch: {
    tenant: function tenant() {
      this.loadData();
    }
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      return ApiService.getOauthClientsForTenant(this.tenant.id).then(function (clients) {
        _this.clients = (clients || []).map(function (client) {
          client.json = JSON.stringify(client.properties, null, 4);
          client.clientColor = 'none';
          return client;
        });
      });
    },
    addClient: function addClient() {
      var emptyClient = {
        name: '',
        description: '',
        logo: '',
        json: JSON.stringify({
          client_id: '',
          client_secret: '',
          auth_uri: '',
          token_uri: '',
          user_info_uri: '',
          redirect_uri: 'https://api.<<your_niota_domain>>/api/v1/oauth2/callback',
          scope: ''
        }, null, 4),
        clientColor: 'none'
      };
      this.clients.unshift(emptyClient);
      this.clients = cloneDeep(this.clients);
    },
    validateAndSave: function () {
      var _validateAndSave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(index) {
        var _this2 = this;

        var persistPromise;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.clients[index].properties = JSON.parse(this.clients[index].json);
                _context.next = 9;
                break;

              case 4:
                _context.prev = 4;
                _context.t0 = _context["catch"](0);
                this.setClientColor(index, 'failed');
                this.$snack(_context.t0.message, 'error');
                return _context.abrupt("return");

              case 9:
                _context.prev = 9;
                _context.next = 12;
                return ApiService.validateOauthClient(this.clients[index].properties);

              case 12:
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t1 = _context["catch"](9);
                this.setClientColor(index, 'failed');
                this.$snack(_context.t1.response.data.message, 'error');
                return _context.abrupt("return");

              case 19:
                persistPromise = Promise.resolve();
                this.clients[index].clientColor = undefined;

                if (this.clients[index].clientId) {
                  persistPromise = ApiService.updateOauthClient(this.clients[index].clientId, this.clients[index]);
                } else {
                  persistPromise = ApiService.createOauthClient(this.tenant.id, this.clients[index]);
                }

                return _context.abrupt("return", persistPromise.then(function (clientObj) {
                  clientObj.json = JSON.stringify(clientObj.properties, null, 4);
                  _this2.clients[index] = clientObj;

                  _this2.setClientColor(index, 'saved');

                  _this2.clients = cloneDeep(_this2.clients);

                  _this2.$snack('Validated and saved');
                }).catch(function (error) {
                  _this2.clients[index].clientColor = 'red';

                  if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
                    _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
                  } else {
                    _this2.$snack("".concat(error.response.data.message), 'error');
                  }
                }));

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 4], [9, 14]]);
      }));

      function validateAndSave(_x) {
        return _validateAndSave.apply(this, arguments);
      }

      return validateAndSave;
    }(),
    deleteClient: function deleteClient(index) {
      var _this3 = this;

      return ApiService.deleteOauthClient(this.clients[index].clientId).then(function () {
        pullAt(_this3.clients, [index]);
        _this3.clients = cloneDeep(_this3.clients);
      });
    },
    changeLogo: function changeLogo(index) {
      var _this4 = this;

      var file = this.$refs.attachmentInput[index].files[0];

      if (file.size > 1024 * 1024) {
        this.$snack('Image size should not exceed 512 kb', 'error');
        this.$refs.attachmentInput[index].files[0].value = null;
        return;
      }

      var reader = new FileReader();

      reader.onload = function (f) {
        _this4.clients[index].logo = f.target.result;
      };

      reader.readAsDataURL(file);
      this.setClientColor(index, 'changed');
    },
    removeLogo: function removeLogo(index) {
      this.clients[index].logo = null;
      this.setClientColor(index, 'changed');
    },
    setClientColor: function setClientColor(index, type) {
      var _this5 = this;

      switch (type) {
        case 'changed':
          this.clients[index].clientColor = 'orange';
          break;

        case 'saved':
          this.clients[index].clientColor = 'green';
          break;

        case 'failed':
          this.clients[index].clientColor = 'red';
          break;

        default:
          this.clients[index].clientColor = 'none';
      }

      if (type === 'saved') {
        setTimeout(function () {
          _this5.clients[index].clientColor = 'none';
        }, 2000);
      }
    }
  }
};